import { render, staticRenderFns } from "./Block4Vue.vue?vue&type=template&id=09cc0ef8&scoped=true"
import script from "./Block4Vue.vue?vue&type=script&lang=js"
export * from "./Block4Vue.vue?vue&type=script&lang=js"
import style0 from "./Block4Vue.vue?vue&type=style&index=0&id=09cc0ef8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "09cc0ef8",
  null
  
)

export default component.exports